import React from "react";
import * as FileSaver from "file-saver";
import * as ExcelJs from "exceljs";
import "./DownloadInfoTableExcel.scss";

import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as ReportIcon } from "static/icons/report-download.svg";

const DownloadInfoTableExcel = ({ header, fileName, tabs }) => {


  const fileType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
  const fileExtension = ".xlsx";

  const exportToCSV = () => {

      // Create workbook and sheet
      const workbook = new ExcelJs.Workbook();

      tabs.forEach((tab) => {

          let excelHeader = null;
          let excelLines = [];

          const sheet = workbook.addWorksheet(tab.title);

          // Add Checked to header
          tab.lines.length ? excelHeader = ["", ...tab.header] : excelHeader = [];

          // Add column headers
          sheet.columns = excelHeader.map((columnHeader) => {
              return {header: columnHeader, key: columnHeader};
          });

          for (let i = 0; i < tab.lines.length; i++) {
              excelLines.push(["", ...tab.lines[i]]);
          }

          // Add rows with headers and lines data
          for (let i = 0; i < excelLines.length; i++) {
              sheet.addRow(excelLines[i]);
          }

          sheet.addRow([""]);

          if (tab.lines.length) {
              sheet.addRow(["Total:"]);
          }

          if (excelLines.length > 0) {
              // add count
              let cellRef = "B" + (excelLines.length + 3);
              let cellValue = {
                  formula: "COUNTA(B" + 2 + ":B" + (excelLines.length + 1) + ")",
              };
              sheet.getCell(cellRef).value = cellValue;

              // add sums line
              for (let i = 3; i <= excelHeader.length; i++) {
                  cellRef = letterFromNumber(i) + (excelLines.length + 3);
                  cellValue = {
                      formula:
                          "SUM(" +
                          letterFromNumber(i) +
                          2 +
                          ":" +
                          letterFromNumber(i) +
                          (excelLines.length + 1) +
                          ")",
                  };
                  sheet.getCell(cellRef).value = cellValue;
              }
          }

          // Style excel sheet
          // Color need to be in hex8 code format
          // use this website for example to get hex8 color code https://www.schemecolor.com/
          const colorFillHeader = "F3F6F8FF";
          const colorFillTotals = "FF95B3D7";
          const commonPatternFill = "solid";
          const colorBorder = "FF181818";
          const colorMissing = "FF3D00";
          const borderStyle = "thin";
          const alignmentCenter = {
              vertical: "middle",
              horizontal: "center",
              wrapText: true,
          };

          const borderThinBlack = {
              top: {style: borderStyle, color: {argb: colorBorder}},
              right: {style: borderStyle, color: {argb: colorBorder}},
              bottom: {style: borderStyle, color: {argb: colorBorder}},
              left: {style: borderStyle, color: {argb: colorBorder}},
          };

          const headerRowIndex = 1;
          const totalsRowIndex = sheet.rowCount;

          for (let rowIndex = 1; rowIndex <= sheet.rowCount; rowIndex++) {
              for (
                  let columnIndex = 1;
                  columnIndex <= sheet.columnCount;
                  columnIndex++
              ) {
                  const cell = sheet.getCell(rowIndex, columnIndex);
                  cell.alignment = alignmentCenter;
                  cell.border = borderThinBlack;

                  if (rowIndex === headerRowIndex) {
                      cell.font = {
                          bold: true,
                          size: 14,
                      };

                      cell.fill = {
                          type: "pattern",
                          pattern: commonPatternFill,
                          fgColor: {argb: colorFillHeader},
                      };
                  } else if (rowIndex === totalsRowIndex) {
                      cell.fill = {
                          type: "pattern",
                          pattern: commonPatternFill,
                          fgColor: {argb: colorFillTotals},
                      };
                  } else {
                      // Other rows except the header
                      cell.font = {
                          size: 12,
                      };
                  }

                  if (String(cell["_value"]["model"]["value"]).includes("missing")) {
                      cell.fill = {
                          type: "pattern",
                          pattern: "solid",
                          fgColor: {argb: colorMissing},
                      };
                  }
              }
          }

          //Autosize column width
          autosizeColumnsWidth(sheet);

          // Conditional formatting dependent on value in first column
          addConditionalFormatting(sheet);
      })

      workbook.xlsx.writeBuffer().then(function (buffer) {
          const blob = new Blob([buffer], {type: fileType});
          // save excel file
          FileSaver.saveAs(blob, fileName + fileExtension);
      });
  };

  return (
    <UniversalButton
      label={"Download report"}
      leftIcon={<ReportIcon className="download-excel__button_icon" />}
      size="md"
      isRounded="sm"
      labelColor="white"
      labelHoverColor="white"
      backgroundColor="blue-dark"
      backgroundHoverColor="blue-light"
      onClick={exportToCSV}
    />
  );
};

function addConditionalFormatting(sheet) {
  const cellRefStart = "A2";
  const cellRefEnd = sheet.getCell(
    sheet.rowCount - 1,
    sheet.columnCount
  ).address;

  const ref = cellRefStart + ":" + cellRefEnd;
  sheet.addConditionalFormatting({
    ref: ref,
    rules: [
      {
        type: "expression",
        formulae: ["=EXACT($A2, TRUE)"],
        style: {
          fill: {
            type: "pattern",
            pattern: "solid",
            bgColor: { argb: "FFEBF1DE" },
          },
        },
      },
    ],
  });
}

function autosizeColumnsWidth(sheet) {
  sheet.columns.forEach((column) => {
    const lengths = column.values.map((value) => value.toString().length);
    if(column.width){
      column.width = Math.max(
          Math.max(...lengths.filter((value) => typeof value === "number")) + 2,
          column.header.length + 6
      )
    };
  });
}

function letterFromNumber(number) {
  if (number <= 26) {
    return String.fromCharCode(96 + number).toUpperCase();
  } else {
    return (
      letterFromNumber(Math.floor(number / 26)) + letterFromNumber(number % 26)
    );
  }
}

export default DownloadInfoTableExcel;
